import { createUserReadService, createAuthSessionReadService } from '../application/createUserReadService';
import { supabaseUserReadPort, supabaseAuthSessionReadPort } from '../infrastructure/supabaseUserReadPort';

export const userReadService = createUserReadService(supabaseUserReadPort);
export const authSessionReadService = createAuthSessionReadService(supabaseAuthSessionReadPort);
